import { useGlobalAppState } from '../../../context/GlobalAppState';

export const usePdpV2QueryEnabled = () => {
  const { dynamicFeatureFlags } = useGlobalAppState();

  return dynamicFeatureFlags.isPdpV2QueryEnabled;
};
